import loadable from '@loadable/component';
import loadableModule from '../../loadable-module';

const DynamicQuestionModule = loadableModule({
    LoadableComponent: loadable(() =>
        import(
            /* webpackChunkName: "dynamic-question" */
            './DynamicQuestion'
        )
    ),
    componentName: 'DynamicQuestion',
    placeholder: {
        placeholderType: 'Block',
        size: 'md',
    },
});
export default DynamicQuestionModule;
